<template>
  <div class="completa-registrazione">
    <h3 v-if="!confermata">{{ labels.clicca_sul_pulsante }}</h3>
    <br />
    <h3>
      <b-button
        variant="success"
        size="sm"
        v-if="!confermata"
        v-on:click="conferma"
        :disabled="invio_in_corso"
        >{{ labels.completa_registrazione }}</b-button
      >
    </h3>

    <div v-if="confermata">
      <b-alert show fade variant="warning">{{
        labels.registrazione_completata
      }}</b-alert>
      <br />
      <br />
      <router-link to="/login">{{ labels.vai_a_login }}</router-link>
    </div>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  name: "CompletaRegistrazione",
  components: {},
  data() {
    return {
      chiave: "",
      confermata: false,
      labels: {},
      labels_errori: {},
      invio_in_corso: false,
    };
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },

  methods: {
    conferma() {
      try {
        let me = this;

        let parametri = {
          chiave: this.chiave,
        };
        let parametri_json = JSON.stringify(parametri);

        let ServerURL = this.$store.state.ServerURL;
        fn_CambiaCursore("wait", this);
        this.invio_in_corso = true;

        axios({
          method: "post",
          url: ServerURL + "CheckIn/CompletaRegistrazione",
          data: parametri_json,
        })
          .then(function (response) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            if (response.data.errore == 0) {
              me.$bvModal
                .msgBoxOk(me.labels.registrazione_completata, {
                  title: me.labels.conferma_della_registrazione,
                })
                .then(function () {
                  me.confermata = true;
                });
            } else if (response.data.errore == -2) {
              me.registraErrore(
                response.data.esito,
                "CompletaRegistrazione-conferma"
              );
            } else {
              me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
                title: me.labels_errori.si_e_verificato_un_errore,
                bodyClass: "errore",
              });
            }
          })
          .catch(function (error) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            me.registraErrore(error, "CompletaRegistrazione-conferma");
          });
      } catch (error) {
        this.invio_in_corso = false;
        this.registraErrore(error, "CompletaRegistrazione-conferma");
      }
    },
  },
  created() {
    try {
      fn_CambiaLingua(this.$store.state.Lingua, this);
      this.chiave = this.$route.query.chiave;
    } catch (error) {
      this.registraErrore(error, "CompletaRegistrazione-created");
    }
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      clicca_sul_pulsante:
        "Clicca sul pulsante per completare il processo di registrazione",
      completa_registrazione: "Completa registrazione",
      registrazione_completata: "Registrazione completata regolarmente",
      conferma_della_registrazione: "Conferma registrazione",
      vai_a_login: "Login",
    };
    let labels_inglese = {
      clicca_sul_pulsante:
        "Clicca sul pulsante per completare il processo di registrazione",
      completa_registrazione: "Completa registrazione",
      registrazione_completata: "Registrazione completata regolarmente",
      conferma_della_registrazione: "Conferma registrazione",
      vai_a_login: "Login",
    };
    let labels_tedesco = {
      clicca_sul_pulsante:
        "Clicca sul pulsante per completare il processo di registrazione",
      completa_registrazione: "Completa registrazione",
      registrazione_completata: "Registrazione completata regolarmente",
      conferma_della_registrazione: "Conferma registrazione",
      vai_a_login: "Login",
    };
    let labels_francese = {
      clicca_sul_pulsante:
        "Clicca sul pulsante per completare il processo di registrazione",
      completa_registrazione: "Completa registrazione",
      registrazione_completata: "Registrazione completata regolarmente",
      conferma_della_registrazione: "Conferma registrazione",
      vai_a_login: "Login",
    };

    let labels_errori_italiano = {
      codice_non_trovato: "Codice non trovato",
      codice_gia_confermato: "Codice già confermato",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_inglese = {
      codice_non_trovato: "Codice non trovato",
      codice_gia_confermato: "Codice già confermato",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_tedesco = {
      codice_non_trovato: "Codice non trovato",
      codice_gia_confermato: "Codice già confermato",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_francese = {
      codice_non_trovato: "Codice non trovato",
      codice_gia_confermato: "Codice già confermato",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "CompletaRegistrazione-fn_CambiaLingua");
  }
}

function fn_CambiaCursore(cursore, vm) {
  document.querySelector("body").style.cursor = cursore;

  if (cursore == "wait") {
    vm.invio_in_corso = true;
  } else {
    vm.invio_in_corso = false;
  }
}
</script>

<style scoped></style>
